import { render, staticRenderFns } from "./pageChange.vue?vue&type=template&id=748cda20&"
import script from "./pageChange.vue?vue&type=script&lang=ts&"
export * from "./pageChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports